import { useBasicFileUpload, UseFileUpload } from './useBasicFileUpload';
import { validateFile } from './utils/validateFile';

export const useFileUpload = (props: UseFileUpload) =>
  useBasicFileUpload({
    ...props,
    validate: validateFile,
  });
